var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBridgeWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 44.5,
    stroke: "url(#paint0_linear_453_3664)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0007 50.4481C25.519 39.9078 34.5458 31.7829 45.417 31.7829C56.2882 31.7829 65.315 39.9078 66.8333 50.4481H71.6135C70.0596 37.2653 58.9097 27 45.417 27C31.9243 27 20.7684 37.2653 19.2145 50.4481H23.9948H24.0007Z",
    fill: "url(#paint1_linear_453_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9308 57.8615C25.2064 57.8615 27.8617 55.1848 27.8617 51.8829C27.8617 48.581 25.2064 45.9043 21.9308 45.9043C18.6553 45.9043 16 48.581 16 51.8829C16 55.1848 18.6553 57.8615 21.9308 57.8615Z",
    fill: "#077368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0692 57.8615C72.3447 57.8615 75 55.1848 75 51.8829C75 48.581 72.3447 45.9043 69.0692 45.9043C65.7937 45.9043 63.1384 48.581 63.1384 51.8829C63.1384 55.1848 65.7937 57.8615 69.0692 57.8615Z",
    fill: "#F25041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_453_3664",
    x1: 6.5,
    y1: 33,
    x2: 80.5,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BAB9AC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26348"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_453_3664",
    x1: 22.9573,
    y1: 35.5031,
    x2: 52.2637,
    y2: 58.9558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BAB9AC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26348"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_3664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 30.8615,
    fill: "white",
    transform: "translate(16 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeWallet);
export default __webpack_public_path__ + "static/media/Bridge-Wallet.478c7c96d927286c9537bb9751503c6a.svg";
export { ForwardRef as ReactComponent };